import React from 'react'

export default function Tooltip({ content, placement = 'top', children, className = '' }) {
    if (!content) return <>{children}</>

    let placementClass = 'bottom-full mb-2 left-1/2 -translate-x-1/2'

    if (placement === 'bottom') placementClass = 'top-full mt-2 left-1/2 -translate-x-1/2'
    if (placement === 'left') placementClass = 'right-full mr-2 top-1/2 -translate-y-1/2'
    if (placement === 'right') placementClass = 'left-full ml-2 top-1/2 -translate-y-1/2'

    return (
        <span className={`relative inline-flex group ${className}`}>
            {children}
            <span
                className={`pointer-events-none absolute z-50 whitespace-nowrap rounded bg-gray-700 text-white text-xs px-2 py-1 shadow-md opacity-0 transition-opacity duration-150 group-hover:opacity-100 group-focus-within:opacity-100 ${placementClass}`}
            >
                {content}
            </span>
        </span>
    )
}
